import { CompanyDto } from "../dto";
import { Api } from "../helpers";

export class CompanyApi {
  static async getAll(): Promise<CompanyDto[] | undefined> {
    const response = await Api.get<CompanyDto[]>("/api/v1/core/companies");

    return response?.data;
  }

  static async create(data: CompanyDto): Promise<CompanyDto | undefined> {
    const response = await Api.post<CompanyDto>("/api/v1/core/companies", data);

    return response?.data;
  }

  static async update(data: CompanyDto): Promise<CompanyDto | undefined> {
    const response = await Api.patch<CompanyDto>(
      `/api/v1/core/companies/${data.id}`,
      data,
    );

    return response?.data;
  }

  static async delete(id: number): Promise<CompanyDto | undefined> {
    const response = await Api.delete<CompanyDto>(
      `/api/v1/core/companies/${id}`,
    );

    return response?.data;
  }
}
